import { render } from "./controls.vue?vue&type=template&id=5b0db597&scoped=true&ts=true"
import script from "./controls.vue?vue&type=script&lang=ts"
export * from "./controls.vue?vue&type=script&lang=ts"

import "./controls.vue?vue&type=style&index=0&id=5b0db597&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0db597"]])

export default __exports__